import { forwardRef } from 'react';
import { Icon } from '@iconify/react';
import { Box, SxProps, Theme } from '@mui/material';

interface IconifyProps {
  icon: string;
  size?: number | string;
  sx?: SxProps<Theme>;
  onClick?: () => void;
  color?: string;
}

const Iconify = forwardRef(
  ({ icon, color, size = 20, sx, ...other }: IconifyProps, ref) => (
    <Box
      ref={ref}
      component={Icon}
      icon={icon}
      sx={{ width: size, height: size, ...sx }}
      {...other}
    />
  )
);

Iconify.displayName = 'Iconify';

export default Iconify;
